import { countries } from 'helpers'

const defaultState = {
  userId: undefined,
  username: undefined,
  countryCode: undefined,
  countryShort: undefined,
  email: '',
  organization: '',
  label: '',
  roles: [],
  testmode: false,
  annualPass: {
    elektra_event_no: undefined,
    elektra_debitor_class: undefined,
    elektra_debitor_classes: [],
    email_language: undefined,
    email_languages: {},
    email_template: undefined,
    subscription: undefined
  },
  memberPass: {
    elektra_event_no: undefined,
    elektra_debitor_class: undefined,
    elektra_debitor_classes: [],
    email_language: undefined,
    email_languages: {},
    email_template: undefined,
    subscription: undefined
  },
  seasonPass: {
    elektra_event_no: undefined,
    elektra_debitor_class: undefined,
    elektra_debitor_classes: [],
    email_language: undefined,
    email_languages: {},
    email_template: undefined
  }
}

const settings = (state = defaultState, action) => {
  switch (action.type) {
    case 'INIT_USER': {
      const identity = action.payload
      const userId = identity.user_id
      const username = identity.username
      const countryCode = `+${identity.phone_country_code}`
      const country =
        countries().find(country => country.phone === countryCode) || {}
      const countryShort = country.short
      const roles = identity.roles.map(role => role.toLowerCase())
      const testmode = identity.testmode
      const email = identity.email
      const organization = identity.organization
      const label = identity.label
      const clients = identity.clients
      return {
        ...state,
        userId,
        username,
        countryCode,
        countryShort,
        roles,
        testmode,
        email,
        organization,
        label,
        clients
      }
    }
    case 'SET_ANNUAL_PASS_SETTINGS': {
      return {
        ...state,
        annualPass: {
          ...state.annualPass,
          ...action.payload
        }
      }
    }
    case 'SET_MEMBER_PASS_SETTINGS': {
      return {
        ...state,
        memberPass: {
          ...state.memberPass,
          ...action.payload
        }
      }
    }
    case 'SET_SEASON_PASS_SETTINGS': {
      return {
        ...state,
        seasonPass: {
          ...state.seasonPass,
          ...action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}

export default settings
